"use client";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import Image, { type StaticImageData } from "next/image";
import { type ReactNode, useState } from "react";
import styles from "./slide.module.css";

interface SliderImagesProps {
  children: ReactNode;
  perView?: number;
  customDefaultDots?: string;
}

export function SliderImages({
  children,
  perView,
  customDefaultDots = "",
}: SliderImagesProps) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    slides: {
      perView: perView || 1,
      spacing: 30,
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });
  const dotSlice = typeof perView !== "undefined" && perView >= 1 ? 1 : 0;

  return (
    <div className={styles.slider}>
      <div className="navigation-wrapper">
        <div ref={sliderRef} className="keen-slider">
          {children}
        </div>
      </div>
      {loaded && instanceRef.current && (
        <div className={styles.dots}>
          {[
            ...Array(
              instanceRef.current.track.details?.slides.length - dotSlice
            ).keys(),
          ].map((idx) => {
            return (
              <button
                type="button"
                key={idx}
                onClick={() => {
                  instanceRef.current?.moveToIdx(idx);
                }}
                style={{
                  background:
                    currentSlide === idx
                      ? "var(--clr-current)"
                      : customDefaultDots,
                }}
                className={`${styles.dot}${
                  currentSlide === idx ? ` ${styles.active}` : ""
                }`}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

interface SlideImageProps {
  src: StaticImageData;
  className?: string;
}

export function SlideImage({ src, className }: SlideImageProps) {
  return (
    <div className={"keen-slider__slide"}>
      <div className={styles.slide}>
        <Image className={className} quality={100} src={src} alt={""} />
      </div>
    </div>
  );
}
